import React , {useState , useEffect}  from "react";
import { Class_ETC_Logout } from "../Class/Class_Etc";
import ChangePasswordAction from "../PartialView/ChangePasswordAction";
// eslint-disable-next-line
import { Link , useNavigate } from "react-router-dom";
import Pathurl from "../Class/Pathurl.json";
import { Class_ETC_Encrypt } from "../Class/Class_Etc";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import ConfigETC from "../Class/ConfigETC.json";
function Header() {

  const navigate = useNavigate();
  const [defaultloading] = useState("../dist/img/loading.gif");
  const [defaultstaffpicture] = useState("../dist/img/default-150x150.png");
  const [ActEdit] = useState(Class_ETC_Encrypt("EditProfile"));
  function onclickLogout() {
    Class_ETC_Logout();
  }

  const FullName_Eng = localStorage.getItem("FullName_Eng");
  let FullName_Th = localStorage.getItem("FullName_Th");
  const staff_code = localStorage.getItem("Staff_Code");
  const staff_img_profile = localStorage.getItem("staff_img_profile");
  const staff_img_profile_in_use = staff_img_profile === "" ? defaultstaffpicture : staff_img_profile;
  const tagStaffCode = FullName_Eng !== null ? FullName_Eng.substring(0,1).toUpperCase() : "";
  const isPicture = staff_img_profile === "" ? false : true;
  let com_display = localStorage.getItem("com_display");
  const com_img_loading = localStorage.getItem("com_img_loading");
  const com_img_loading_in_use = com_img_loading === "" ? defaultloading : com_img_loading;
  
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [listAnnounceGetTopbar, setListAnnounceGetTopbar] = useState([]);
  const [listServiceInfoGetTopbar, setListServiceInfoGetTopbar] = useState([]);

  const [announceTopbarShow, setAnnounceTopbarShow] = useState(false);
  const [serviceInfoTopbarShow, setServiceInfoTopbarShow] = useState(false);

  function onclick_ModalShow(Fullname) {

    document.getElementById("lbl_Modal_Fullname_header").innerHTML = Fullname;

    document.getElementById("txt_Modal_New_Password_header").value = "";
    document.getElementById("txt_Modal_New_Password_header").type = "password";
    document.getElementById("i_Modal_New_Password").className = "fa fa-eye";

    document.getElementById("txt_Modal_Confirm_New_Password_header").value = "";
    document.getElementById("txt_Modal_Confirm_New_Password_header").type = "password";
    document.getElementById("i_Modal_Confirm_New_Password").className ="fa fa-eye";
  }

  function GotoStaffProfile(){
    navigate( "../" + Pathurl.m_staff_ae, { 
      state: {
        staff_code: Class_ETC_Encrypt(staff_code),
        act: ActEdit,
      } 
    }); 
    window.location.reload()
  }

  useEffect(() => {
      GetConfig();
      if (isLoadedConfigData === true) {
          BindList_AnnouncementGetTopbar(function () {
          });
          BindList_ServiceInfoGetTopbar(function () {
          });
      }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);
  
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      setAnnounceTopbarShow(false);
      setServiceInfoTopbarShow(false);
      document.getElementById("div_announce").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
      document.getElementById("div_serviceinfo").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
    }
  };

    async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  function onclick_GetTopbar() {
    BindList_AnnouncementGetTopbar(function(){
      if (announceTopbarShow === false) {
        setServiceInfoTopbarShow(false);
        document.getElementById("div_serviceinfo").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
        setAnnounceTopbarShow(true);
        document.getElementById("div_announce").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right show"
      }
      else {
        setAnnounceTopbarShow(false);
        document.getElementById("div_announce").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
      }
    });
  }

  function onclick_ServiceInfoGetTopbar() {
    BindList_ServiceInfoGetTopbar(function(){
      if (serviceInfoTopbarShow === false) {
        setAnnounceTopbarShow(false);
        document.getElementById("div_announce").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
        setServiceInfoTopbarShow(true);
        document.getElementById("div_serviceinfo").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right show"
      }
      else {
        setServiceInfoTopbarShow(false);
        document.getElementById("div_serviceinfo").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
      }
    });
  }

  function onclick_CloseTopbar() {
    BindList_AnnouncementGetTopbar(function(){
      setAnnounceTopbarShow(false);
      document.getElementById("div_announce").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
    });
  }

  function onclick_CloseServiceInfoTopbar() {
    BindList_ServiceInfoGetTopbar(function(){
      setServiceInfoTopbarShow(false);
      document.getElementById("div_serviceinfo").className = "dropdown-menu dropdown-menu-lg dropdown-menu-right"
    });
  }

  async function BindList_AnnouncementGetTopbar(_callback) {
    try {
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = "";

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const response = await fetch(
      configData.API_URL + "Announce_GetTopbar",
      requestOptions
    );

    const json = await response.json();

      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListAnnounceGetTopbar(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setListAnnounceGetTopbar([]);
          if (_callback != null) {
            _callback();
          }
        }
      } else {
        setListAnnounceGetTopbar([]);
        if (_callback != null) {
          _callback();
        }
      }

    } catch {
      setListAnnounceGetTopbar([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindList_ServiceInfoGetTopbar(_callback) {
    try {
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = "";
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const response = await fetch(
      configData.API_URL + "ServiceInfo_GetTopbar",
      requestOptions
    );

    const json = await response.json();

      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListServiceInfoGetTopbar(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setListServiceInfoGetTopbar([]);
          if (_callback != null) {
            _callback();
          }
        }
      } else {
        setListServiceInfoGetTopbar([]);
        if (_callback != null) {
          _callback();
        }
      }

    } catch {
      setListServiceInfoGetTopbar([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  return (
    <>
      {/* Preloader */}
      <div className="preloader flex-column justify-content-center align-items-center">              
        <img
          className="animation__shake"
          src={com_img_loading_in_use}
          alt="img_loading"
          width={150}
        />
      </div>
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light bg-light">
        {/* Left navbar links */}
       
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#!"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <a href="#!" className="nav-link">
             {com_display}
            </a>
          </li>
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">

          {/* <!-- announcement Dropdown Menu --> */}
          <li className="nav-item dropdown">
            {(listAnnounceGetTopbar.length > 0) &&
              <a  
                className="nav-link btn btn-default" 
                // data-toggle="dropdown" 
                href="#!"
                onClick={onclick_GetTopbar}
                >
                  <i 
                  className="fas fa-bullhorn fa-beat-fade fa-lg text-red"
                  ></i>
              </a>
            }
              <div id="div_announce" className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                  <span className="dropdown-item dropdown-header">You have {" " + listAnnounceGetTopbar.length + " " } Announcement</span>
                  <div className="dropdown-divider"></div>
                  <TableContainer>
                    <Table>
                      <TableBody>
                      
                      {(listAnnounceGetTopbar.length === 0 && (
                          <TableRow key={1}>
                            <TableCell colSpan={1} align="center" style={{padding:"0px"}}>
                              {ConfigETC.NoData}
                            </TableCell>
                          </TableRow>
                        )) ||
                        listAnnounceGetTopbar
                        .map((row) => (
                        <TableRow key={row.rowindex}>
                          <TableCell align="left" style={{padding:"5px"}}>
                          <div className="media">
                            <div className="media-body">
                                <h3 className="dropdown-item-title">&nbsp;
                                  {row.announce_header}
                                </h3>
                                <p className="text-sm">&nbsp;
                                {row.announce_text}
                                </p>
                            </div>
                          </div>
                          </TableCell>
                        </TableRow>
                      ))
                      }
                        
                      </TableBody>
                    </Table>
                  </TableContainer>
                  
                  <div className="dropdown-divider"></div>
                   <a href="#!" 
                      className="dropdown-item dropdown-footer"
                      onClick={onclick_CloseTopbar}
                    >Close
                  </a>
              </div>
          </li>

          {/* <!-- Notifications Dropdown Menu --> */}
          <li className="nav-item dropdown pl-1">
              {/* <a className="nav-link btn btn-default" data-toggle="dropdown" href="#!">
                  <i className="fa-solid fas fa-bell fa-lg fa-shake text-warning"></i>
                  
              </a> */}
              {(listServiceInfoGetTopbar.length > 0) &&
              <a 
                className="nav-link btn btn-default" 
                // data-toggle="dropdown" 
                href="#!"
                onClick={onclick_ServiceInfoGetTopbar}
                >
                  <i 
                  className="fa-solid fas fa-bell fa-lg fa-shake text-warning"
                  ></i>
              </a>
            }
              <div id="div_serviceinfo" className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                  <span className="dropdown-item dropdown-header">You have {" " + listServiceInfoGetTopbar.length + " " } Notifications</span>
                  <div className="dropdown-divider"></div>
                  <TableContainer>
                    <Table>
                      <TableBody>
                      
                      {/* <span className="text-sm"> Service expiration in. </span> */}
                      
                      {listServiceInfoGetTopbar
                      .map((row) => (
                        <TableRow key={row.rowindex}>
                          <TableCell align="left" style={{padding:"0px"}}>
                          <a href={"../" + Pathurl.m_serviceinfo} className="dropdown-item">
                            <i className="fas fa-info-circle"></i>
                            <span className="text-sm"> Service expiration in.</span>
                            <div className="float-right text-muted text-sm">{row.service_day_str}</div>
                          </a>
                          </TableCell>
                        </TableRow>
                      ))
                      }
                        
                      </TableBody>
                    </Table>
                  </TableContainer>

                      <div className="float-right text-muted text-sm"></div>

                  
                  <div className="dropdown-divider"></div>
                  <a href="#!" 
                     className="dropdown-item dropdown-footer"
                     onClick={onclick_CloseServiceInfoTopbar}
                    >Close
                  </a>
              </div>
          </li>


          {/* User Account: style can be found in dropdown.less */}
          <li className="nav-item dropdown user user-menu">
            <a
              href="#!"
              className="nav-link dropdown-toggle"
              data-toggle="dropdown"
            >
              {(isPicture === false && (
                  <>
                  <div
                    className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                    style={{
                      display: "inline-block",
                    }}
                  >
                    <i className="fa"> {tagStaffCode} </i>
                  </div>
                </>
              ))
              ||
              (isPicture === true &&(
                <>
                  <img
                    src={staff_img_profile_in_use}
                    className="user-image img-circle elevation-2"
                    alt="img_profile"
                  />
                </>
              ))                      
              }
              <span className="hidden-xs">{FullName_Eng}</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              {/* User image */}
              <li className="user-header bg-gray-dark">
                {(isPicture === false && (
                    <>
                    <div
                      className="profile-user-img img-fluid img-circle img-bordered-sm bg-gray text-center"
                      style={{
                        display: "inline-block",
                        height: "95px",
                        width: "95px",                  
                      }}
                    >
                      <i className="fa" title="logo" style={{fontSize: "55px",padding:"15px",}}>{tagStaffCode}</i>
                    </div>
                  </>
                ))
                ||
                (isPicture === true &&(
                  <>
                    <img
                    src={staff_img_profile_in_use}
                    className="img-circle elevation-2"
                    alt="User "
                  />
                  </>
                ))                      
                }
                <p>
                  {FullName_Eng} - {FullName_Th}
                </p>
              </li>
              {/* Menu Body */}
              <li className="user-body">
                <div className="row">
                  <div className="col-5">
                    {/* <Link href="#!" 
                       to={"../" + Pathurl.m_staff_ae}
                       state={{
                         staff_code: Class_ETC_Encrypt(staff_code),
                         act: ActEdit,
                       }}
                      className="btn btn-default btn-sm text-small"
                     >
                        <i className="fas fa-user"/> Profile
                    </Link> */}
                    <button
                      type="button"
                      id="btn_staff_profile"
                      onClick={GotoStaffProfile}
                      className="btn btn-default btn-sm text-small"
                     >
                        <i className="fas fa-user"/> Profile
                    </button>
                  </div>
                  <div className="col-7">
                    <a href="#!" 
                       className="btn btn-default btn-sm text-small"
                       data-target="#modal-change-pass-header"
                      //  data-target="#modal-change-passy"
                       data-toggle="modal" 
                       onClick={() => onclick_ModalShow(FullName_Eng) }
                    >
                      <i className="fas fa-key" /> Change password
                    </a>
                  </div>
                </div>
              </li>
              {/* Menu Footer*/}
              <li className="user-footer">
              <div className="float-right"> 
                  <a href="#!" className="btn btn-dark" onClick={onclickLogout} > 
                    <i className="nav-icon fa fa-arrow-circle-right"/> Log out 
                  </a>
              </div>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}

      <ChangePasswordAction Act={"header"} />
      
    </>
  );
}

export default Header;
